import api from 'api'

export type SubmitAssessmentEvaluationItem = {
  questionMappingId: number
  evaluation: boolean
  justification?: string | null
}

export type SubmitAssessmentEvaluationsParams = {
  positionId: number
  userId: number
  evaluations: SubmitAssessmentEvaluationItem[]
}

export const submitAssessmentEvaluations = async ({
  positionId,
  userId,
  evaluations,
}: SubmitAssessmentEvaluationsParams): Promise<void> => {
  await api.post(
    `/admin/positions/${positionId}/assessments/user/${userId}/evaluations`,
    {
      evaluations,
    }
  )
}
